
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Camera, History, Home } from "lucide-react";
import { cn } from "@/lib/utils";
import UserMenu from "@/components/UserMenu";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out px-4 py-3",
        scrolled 
          ? "bg-white/80 backdrop-blur-md shadow-sm" 
          : "bg-transparent"
      )}
    >
      <div className="container mx-auto max-w-7xl flex justify-between items-center">
        <Link 
          to="/"
          className="flex items-center gap-2 font-display font-bold text-lg text-primary"
        >
          <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <span className="text-primary font-display text-xl">C</span>
          </div>
          <span className="hidden sm:inline">CraftyJoy</span>
        </Link>
        
        <div className="flex items-center space-x-3">
          <nav className="flex items-center space-x-1">
            <NavLink to="/" active={location.pathname === "/"}>
              <Home size={20} />
              <span className="ml-1 hidden sm:inline text-sm">Home</span>
            </NavLink>
            
            <NavLink to="/camera" active={location.pathname === "/camera"}>
              <Camera size={20} />
              <span className="ml-1 hidden sm:inline text-sm">Capture</span>
            </NavLink>
            
            <NavLink to="/history" active={location.pathname === "/history"}>
              <History size={20} />
              <span className="ml-1 hidden sm:inline text-sm">History</span>
            </NavLink>
          </nav>
          
          <UserMenu />
        </div>
      </div>
    </header>
  );
}

type NavLinkProps = {
  to: string;
  active: boolean;
  children: React.ReactNode;
};

function NavLink({ to, active, children }: NavLinkProps) {
  return (
    <Link
      to={to}
      className={cn(
        "flex items-center px-3 py-2 rounded-lg transition-all duration-200",
        active 
          ? "bg-primary text-primary-foreground shadow-md" 
          : "hover:bg-secondary text-muted-foreground hover:text-foreground"
      )}
    >
      {children}
    </Link>
  );
}

export default Header;
